import React, { useState, useEffect } from "react";
import "./heroSection.css";

interface CarouselItem {
  image: string;
  title: string;
  subtitle?: string;
  cta?: { text: string; link: string };
}

interface HeroSectionProps {
  id?: string;    
  carousel: CarouselItem[];
  variant?: string; 
}

export const HeroSection: React.FC<HeroSectionProps> = ({ carousel }) => {
  const [current, setCurrent] = useState(0);


  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % carousel.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [carousel.length]);

 
  const prevSlide = () =>
    setCurrent(prev => (prev - 1 + carousel.length) % carousel.length);
  const nextSlide = () =>
    setCurrent(prev => (prev + 1) % carousel.length);

  return (
    <div className="hero-section">
      <div className="hero-carousel">
        {carousel.map((slide, idx) => (
          <div
            key={idx}
            className={`hero-slide ${idx === current ? "active" : ""}`}
            style={{
              backgroundImage: `linear-gradient(120deg, rgba(7, 19, 38, 0.72), rgba(6, 94, 105, 0.55)), url(${slide.image})`,
            }}
          >
            <div className="hero-slide-content">
              <h1>{slide.title}</h1>
              <p>{slide.subtitle}</p>
              {slide.cta && (
                <a href={slide.cta.link} className="hero-cta">
                  {slide.cta.text}
                </a>
              )}
            </div>
          </div>
        ))}

        {/* Manual arrows */}
        <button className="hero-arrow left" onClick={prevSlide}>
          &#10094;
        </button>
        <button className="hero-arrow right" onClick={nextSlide}>
          &#10095;
        </button>
      </div>
    </div>
  );
};
